import React, {createContext, useEffect} from 'react';
import {Outlet, useNavigate, useParams} from 'react-router-dom';
import useSiteData from "../hooks/useSiteData";
import useServersData from "../hooks/useServersData";
import {HOME_PAGE} from "../App";

export const SiteDataContext = createContext(null);

export default function SiteDataProvider() {
    const navigate = useNavigate();
    const {server} = useParams();
    const {error: siteDataError} = useSiteData(server, localStorage.getItem('lang'), true);

    const {error: serversDataError} = useServersData(true);

    useEffect(() => {
        if (siteDataError?.response?.status === 404 || serversDataError?.response?.status === 404) {
            navigate(HOME_PAGE, {replace: true});
        }
    }, [siteDataError, serversDataError, navigate]);

    return (
        <SiteDataContext.Provider value={{server}}>
            <Outlet/>
        </SiteDataContext.Provider>
    );
}
